import { render, staticRenderFns } from "./custom-loader.vue?vue&type=template&id=4faa8398&scoped=true&functional=true&"
var script = {}
import style0 from "./custom-loader.vue?vue&type=style&index=0&id=4faa8398&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4faa8398",
  null
  
)

export default component.exports